import http from "@/http/aisea/axios";
const resource = "/enterprises/operations/departments";

export default {
  /**
   * APIでoperationの部署名の一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {string[]} data - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  getOperationDepartmentNames() {
    return http.get(`${resource}/names`);
  },
};
